import backButtonDisplayRequiredComparisonString from 'mini-common-utils/lib/utils/stringForSharedHeaderCheck';
import { getCurrentUrl } from 'window-utils/lib/getCurrentUrl';
import { isOpx } from 'owa-opx';
import { parseUrlSearchParams } from 'mini-common-utils/lib/utils/parseUrlSearchParams';

let showEdgeHeader;

/**
 * @return true when in opx  i.e. extension or when sharedHeader== 0
 */
export function shouldShowBackButton() {
    const backButtonShouldShow =
        isOpx() || parseUrlSearchParams(window.location.search)?.sharedHeader === '0';
    return backButtonShouldShow;
}

/**
 * @return true when in opx  i.e. extension or when sharedHeader!= 0
 */
export function shouldShowEdgeHeader() {
    if (showEdgeHeader !== undefined) {
        return showEdgeHeader;
    }
    showEdgeHeader = !isOpx() && parseUrlSearchParams(window.location.search)?.sharedHeader === '0';
    return showEdgeHeader;
}

export function isEdgeHeaderShown() {
    const parsedUrl = parseUrlSearchParams(getCurrentUrl());
    return (
        !(backButtonDisplayRequiredComparisonString in parsedUrl) ||
        !(parseInt(parsedUrl[backButtonDisplayRequiredComparisonString]) === 1)
    );
}
